import { Download } from 'lucide-react';
import { cn } from '@/lib/utils';

interface CardExportButtonProps {
  onExport: () => void;
  className?: string;
}

export function CardExportButton({ onExport, className }: CardExportButtonProps) {
  return (
    <button
      type="button"
      onClick={onExport}
      className={cn(
        'p-1.5 rounded-md text-muted-foreground hover:text-primary hover:bg-primary/10 transition-colors',
        className
      )}
      aria-label="Exportar dados em CSV"
      title="Exportar CSV"
    >
      <Download className="h-3.5 w-3.5" />
    </button>
  );
}

interface DataCardHeaderProps {
  title: string;
  onExport?: () => void;
}

/** Título 14px semibold — mesmo peso usado nos cards do design system BI. */
export function DataCardHeader({ title, onExport }: DataCardHeaderProps) {
  return (
    <div className="flex items-center justify-between gap-2 mb-4">
      <h3 className="text-sm font-semibold text-foreground">{title}</h3>
      {onExport && <CardExportButton onExport={onExport} />}
    </div>
  );
}
